const localization = {
  dismissLabel: 'Dismiss notification',
}

export default localization
